// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3dH-j","title":"ClientReferral_title__3U1VO","itemText":"ClientReferral_itemText__1oP_l"};